module.exports = __webpack_public_path__ + "media/images/defaultprofessionaldevelopment-c92d5d8d.png";